import { PageLayout, StorefrontSection } from 'types/storefront';

export const defaultHomeLayout: PageLayout = {
  page: 'home',
  sections: [
    {
      id: 'hero-default',
      type: 'hero_banner',
      enabled: true,
      order: 1,
      config: {
        autoplay: true,
        intervalMs: 5000,
        slides: [
          {
            imageUrl: '',
            titleKey: 'home.hero.title',
            subtitleKey: 'home.hero.subtitle',
            linkUrl: '/catalogo',
          },
        ],
      },
    },
    {
      id: 'cats-default',
      type: 'featured_categories',
      enabled: true,
      order: 2,
      config: { columns: 4 },
    },
    {
      id: 'promo-default',
      type: 'promotions_carousel',
      enabled: true,
      order: 3,
      config: { limit: 8 },
    },
    {
      id: 'news-default',
      type: 'new_products',
      enabled: true,
      order: 4,
      config: { limit: 8, showPrice: true },
    },
  ],
};

export const getDefaultLayout = (page: string): PageLayout | null => {
  if (page === 'home') return defaultHomeLayout;
  return null;
};

export const sortEnabledSections = (sections: StorefrontSection[]): StorefrontSection[] =>
  sections.filter((s) => s.enabled).sort((a, b) => a.order - b.order);
